import { useEffect, useRef } from "react";

export default function AutoTextarea({ value, className = "", minRows = 6, inputRef, ...props }) {
  const inner = useRef(null);
  const ref = inputRef || inner;
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight + 2}px`;
  }, [value]);
  return (
    <textarea
      ref={ref}
      rows={minRows}
      value={value}
      data-lenis-prevent
      className={`${className} resize-none overflow-hidden`}
      {...props}
    />
  );
}
